import {
  getLlmsTxt as publicGetLlmsTxt,
  updateLlmsTxt as publicUpdateLlmsTxt,
  appendLlmsTxt as publicAppendLlmsTxt,
  updateLlmsTxtHiddenStatus as publicUpdateLlmsTxtHiddenStatus,
} from './promote-seo-v2-llms-txt-llms-txt.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getLlmsTxt: MaybeContext<
  BuildRESTFunction<typeof publicGetLlmsTxt> & typeof publicGetLlmsTxt
> = /*#__PURE__*/ createRESTModule(publicGetLlmsTxt);
export const updateLlmsTxt: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLlmsTxt> & typeof publicUpdateLlmsTxt
> = /*#__PURE__*/ createRESTModule(publicUpdateLlmsTxt);
export const appendLlmsTxt: MaybeContext<
  BuildRESTFunction<typeof publicAppendLlmsTxt> & typeof publicAppendLlmsTxt
> = /*#__PURE__*/ createRESTModule(publicAppendLlmsTxt);
export const updateLlmsTxtHiddenStatus: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLlmsTxtHiddenStatus> &
    typeof publicUpdateLlmsTxtHiddenStatus
> = /*#__PURE__*/ createRESTModule(publicUpdateLlmsTxtHiddenStatus);

export { WebhookIdentityType } from './promote-seo-v2-llms-txt-llms-txt.universal.js';
export {
  LlmsTxt,
  GetLlmsTxtRequest,
  GetLlmsTxtResponse,
  UpdateLlmsTxtRequest,
  UpdateLlmsTxtResponse,
  AppendLlmsTxtRequest,
  AppendLlmsTxtResponse,
  UpdateLlmsTxtHiddenStatusRequest,
  UpdateLlmsTxtHiddenStatusResponse,
  UpdateLlmsTxtManuallyEditedStatusRequest,
  UpdateLlmsTxtManuallyEditedStatusResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetLlmsTxtOptions,
  UpdateLlmsTxtOptions,
  AppendLlmsTxtOptions,
  UpdateLlmsTxtHiddenStatusOptions,
} from './promote-seo-v2-llms-txt-llms-txt.universal.js';
export { WebhookIdentityTypeWithLiterals } from './promote-seo-v2-llms-txt-llms-txt.universal.js';
